/**
 * Shared cents → localized currency formatter for the admin metrics plane.
 * Extracted from AdminMetricsPage so new admin metric pages (F133) don't
 * duplicate the formatting logic.
 */
export function formatCents(cents: number, currency: string): string {
  const amount = cents / 100;
  if (currency === 'BRL') {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount);
  }
  return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(amount);
}
